export const GLOBAL_ENTRY_SUFFIX = {
  FIELD: 'global-field',
  METHOD: 'global-method',
  TYPE: 'global-type',
} as const
